<div class="bank-info-container">
  <div class="bank-logo-wrapper">
    @if ((logo || imageSrc)) {
    <img class="bank-logo" [src]="logo || imageSrc" pbbImgError="{{ defaultLogoPath }}" alt="Bank Logo" />
    } @else {
    <mat-icon class="bank-logo" aria-hidden="true">account_balance</mat-icon>
    }
  </div>
  <div class="bank-name">
    <span class="mat-body-1 text-bold">{{ name || 'Bank Account' }}</span>
  </div>
</div>
